<script lang="ts">
	export let type = 'body2';
	export let gutter = false;
	export let inline = false;
</script>

<div on:mouseover on:mouseout class:inline class:gutter class={`mdc-typography--${type}`}>
	<slot />
</div>

<style>
	.gutter {
		margin-bottom: 0.35em;
	}
	.inline {
		display: inline-block;
	}
</style>
